import { useState, useRef } from 'react';
import { toast } from 'sonner';
import { Camera, Loader2 } from 'lucide-react';
import { Button } from '../ui/button';
import { ScanDocumentDialog } from './ScanDocumentDialog';
import { PhotoIdentiteDialog } from './PhotoIdentiteDialog';
import { preparerPage, CARTES, MULTI_PAGES } from './scanUtils';

// Bouton « Photographier » : ouvre l'appareil photo puis le scanner (documents) ou le cadrage (photo d'identité)
export const BoutonPhotographier = ({ doc, onFichier, disabled, suffixe = '', className = '' }) => {
  const [premiere, setPremiere] = useState(null);
  const [busy, setBusy] = useState(false);
  const input = useRef(null);
  const photo = doc.id === 'photo_identite';
  const choisir = async (e) => {
    const f = e.target.files?.[0];
    e.target.value = '';
    if (!f) return;
    setBusy(true);
    try { setPremiere(await preparerPage(f)); } catch { toast.error('Photo illisible, réessayez'); } finally { setBusy(false); }
  };
  const fermer = () => setPremiere(null);
  return (
    <>
      <Button size="sm" variant="outline" className={`text-xs border-[#8DC63F] text-[#5a8a1f] hover:bg-[#8DC63F]/10 ${className}`} disabled={disabled || busy}
        onClick={() => input.current?.click()} data-testid={`btn-photographier-${doc.id}${suffixe}`}>
        {busy ? <Loader2 className="h-3 w-3 animate-spin" /> : <><Camera className="h-3 w-3 mr-1" /> Photographier</>}
      </Button>
      <input ref={input} type="file" accept="image/*" capture={photo ? 'user' : 'environment'} className="hidden" onChange={choisir} data-testid={`input-photographier-${doc.id}${suffixe}`} />
      {premiere && (photo
        ? <PhotoIdentiteDialog doc={doc} premiere={premiere} onClose={fermer} onFichier={onFichier} />
        : <ScanDocumentDialog doc={doc} mode={CARTES.includes(doc.id) ? 'carte' : 'document'} multi={MULTI_PAGES.includes(doc.id)} premiere={premiere} onClose={fermer} onFichier={onFichier} />)}
    </>
  );
};
